module.exports = __webpack_public_path__ + "img/charge-marker-4.9697c55a.png";